/* tslint:disable:component-selector */
import { Component, HostListener, Input, OnInit } from '@angular/core';
import * as echarts from 'echarts';


@Component({
  selector: 'scale-area',
  templateUrl: './scale-area.component.html',
  styleUrls: ['./scale-area.component.css']
})
export class ScaleAreaComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  public innerWidth: any;

  title: string;
  option: object;

  @Input() chartTitle: string;
  @Input() country: string;

  @Input() seriesName: string;
  @Input() data: number[];
  @Input() date: any[];


  ngOnInit(): void {
    this.title = this.chartTitle + '—' + this.country;
    this.option = {
      tooltip: {
        trigger: 'axis',
      },
      title: {
        left: 'center',
        text: this.title,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: 'Download image'
          },
          dataZoom: {
            title: 'as',
            yAxisIndex: 'none'
          }
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.date
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, '100%']
      },
      dataZoom: [{
        type: 'inside',
        start: 0,
        end: 10
      }, {
        start: 0,
        end: 10,
        handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        handleSize: '80%',
        handleStyle: {
          color: '#fff',
          shadowBlur: 3,
          shadowColor: 'rgba(0, 0, 0, 0.6)',
          shadowOffsetX: 2,
          shadowOffsetY: 2
        }
      }],
      series: [
        {
          name: this.seriesName,
          type: 'line',
          smooth: true,
          symbol: 'none',
          sampling: 'average',
          itemStyle: {
            color: 'rgb(155,82,109)'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgb(255, 158, 68)'
            }, {
              offset: 1,
              color: 'rgb(255, 70, 131)'
            }])
          },
          data: this.data
        }
      ]
    };
    this.innerWidth = window.innerWidth;
  }

  onResize(event): void {
    this.innerWidth = window.innerWidth;
  }

}
